// Signup.js

import React from 'react';
import Navigation from '../components/nav'
import RegisterForm from '../components/Auth/RegisterForm';

const Register = () => {
 

  return (
    <>  
    <Navigation />
       <RegisterForm />
    </>
  );
};

export default Register;
